import { useEffect, useRef } from 'react';
import { useSocket } from '../context/SocketContext';

/**
 * Subscribe to Socket.IO events on the shared connection.
 * @param {Record<string, Function>} handlers — event name → callback
 */
export function useSocketEvents(handlers) {
  const { socket } = useSocket();
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!socket) return undefined;

    const wrappers = Object.entries(handlersRef.current || {})
      .filter(([, fn]) => typeof fn === 'function')
      .map(([event, fn]) => {
        const wrapper = (...args) => handlersRef.current[event]?.(...args);
        socket.on(event, wrapper);
        return [event, wrapper];
      });

    return () => {
      wrappers.forEach(([event, wrapper]) => socket.off(event, wrapper));
    };
  }, [socket]);
}
